import {Box, HBox} from '../../../components/core/view';
import {H3Text, H5Text, H6Text} from '../../../components/core/text';
import React, {Fragment, useCallback, useState} from 'react';
import {ReceiptBypassMode, RunForBatchDetail} from '@buncha/batchDetails/types';

import {BottomButton} from '../../../components/composites/Button';
import If from '@buncha/components/conditional/If';
import {Modules} from '@buncha/utils/types';
import SampleImage from '../SampleImage/SampleImage';
import Scrollview from '@buncha/components/composites/scrollview';
import {ShopperScreens} from '@buncha/home/navigation/types';
import {SpinnerComponent} from '@buncha/components/core/loader';
import {Touchable} from '@buncha/components/core/touchable';
import UnreadChatModal from '@buncha/batchDetails/component/unreadChatModal';
import listener from '@buncha/config/listener';
import {styles} from './Styles';
import {useColorThemeType} from '../../../appStyles/hooks/theme';
import {useGetChatUnreadCount} from '@buncha/batchDetails/hooks/BatchDetails';
import {useGetLocale} from '@buncha/localization/hooks';

const UploadTutorial = (props: {
  onTakePhoto: any;
  hasSkip?: ReceiptBypassMode;
  skipReceiptHandler?: () => void;
  runDetail?: RunForBatchDetail | null;
  closeModal: () => void;
}) => {
  const theme = useColorThemeType();
  const {title, body, button} =
    useGetLocale(Modules.batchDetails, ShopperScreens.BatchDetailsPage) ?? {};

  const [unreadChatCount, setUnreadChatCount] = useState(0);
  const {chatLoading, getChatUnreadCount} = useGetChatUnreadCount();

  const clearChatCount = useCallback(() => {
    setUnreadChatCount(0);
    props.closeModal();
  }, [props]);

  const handleUploadReceipt = useCallback(async () => {
    const conversationIds = props.runDetail?.ordersForShopper?.map(
      order => order.buyerChatInfo?.conversationId,
    );
    const unreadCount = conversationIds?.length
      ? await getChatUnreadCount(conversationIds)
      : 0;
    listener.emit('chatCount', unreadCount);
    if (!unreadCount) return props.onTakePhoto();
    return setUnreadChatCount(unreadCount);
  }, [getChatUnreadCount, props]);

  return (
    <Fragment>
      <Box style={[styles.body]}>
        <Scrollview style={styles.scrollStyles}>
          <Box>
            <If condition={props?.hasSkip === ReceiptBypassMode.showSkip}>
              <Touchable
                activeOpacity={0.5}
                onPress={props?.skipReceiptHandler}>
                <H5Text
                  style={[styles.skipText, {color: theme?.text.green[100]}]}>
                  {button?.skip}
                </H5Text>
              </Touchable>
            </If>
            <HBox style={[styles.centerBox]}>
              <Box style={[styles.typoBox]}>
                <H3Text style={{color: theme?.text.blue[300]}}>
                  {title?.inStorePrice}
                </H3Text>
                <H6Text style={[styles.subTitle]}>{body?.captureNames}</H6Text>
              </Box>
            </HBox>
            <HBox style={[styles.imageContainer]}>
              <SampleImage header="Do ✅" isDo={true} />
              <SampleImage header="Don't ❌" isDo={false} />
            </HBox>
          </Box>
        </Scrollview>
        <BottomButton
          isLoading={chatLoading}
          disabled={chatLoading}
          loadingIndicator={<SpinnerComponent />}
          style={[styles.buttonStyle]}
          onPress={handleUploadReceipt}
          title={button?.submitReceipt}
        />
      </Box>
      <UnreadChatModal
        count={unreadChatCount}
        onClose={clearChatCount}
        runId={props.runDetail?.id ?? 0}
      />
    </Fragment>
  );
};

export default React.memo(UploadTutorial);
